import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { removeAccents } from 'utils/string';
import SimpleCarousel from 'components/SimpleCarousel';
import IconSearch from 'assets/images/icons/search-solid.svg';
import Faces from 'components/Steps/Faces';
import FeedbackModal from 'components/FeedbackModal';
import UserSmallCard from 'components/Cards/UserSmallCard';
import NoResultsImg from 'assets/images/speed_dating/no_results.svg';
import { AddUsersWrapper, Searcher, SearcherInput } from './styles';

class AddUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      selectedUsers: [],
      showPopupInvited: false,
    };
  }

  handleInvite = () => {
    const {
      isLoading, popUp, onInvite, onCancel,
    } = this.props;
    const { selectedUsers } = this.state;

    if (!isLoading && popUp) {
      this.setState({ showPopupInvited: true }, this.handleModalInvite);
    }
    if (!popUp) {
      onInvite(selectedUsers);
      onCancel();
    }
  }

  handleModalInvite = () => {
    const { onInvite } = this.props;
    const { selectedUsers } = this.state;
    onInvite(selectedUsers);
  }

  handleCloseModalInviteFeedback = () => {
    const { onCancel } = this.props;
    this.setState({ showPopupInvited: false });
    onCancel();
  }

  handleSearchChange = (event) => {
    const { value } = event.target;
    this.setState({ search: value });
  }

  handleSelectFace = (userId) => {
    const { selectedUsers } = this.state;
    const { connections } = this.props;

    const user = _.find(connections, { id: userId });
    if (user) {
      selectedUsers.push(user);
      this.setState({ selectedUsers });
    }
  }

  handleUnselectFace = (event) => {
    const userId = parseInt(event.currentTarget.getAttribute('data-user'), 10);
    const { selectedUsers } = this.state;
    _.remove(selectedUsers, { id: userId });
    this.setState({ selectedUsers });
  }

  doNothing = () => {

  }

  printSearchResults = () => {
    const { connections, excludedUsers, literals } = this.props;
    const { search } = this.state;

    const searchValue = removeAccents(search.toLowerCase());

    const searchResults = connections.filter((user) => {
      if (excludedUsers.includes(user.id)) {
        return false;
      }

      if (!searchValue) {
        return true;
      }

      const userName = removeAccents(`${user.firstname} ${user.lastname}`.toLowerCase());
      if (userName.indexOf(searchValue) !== -1) {
        return true;
      }

      return false;
    });

    if (!searchResults.length) {
      return (
        <div className='no_elements'>
          <img alt='' src={NoResultsImg} />
          <div>
            {literals.noUsers}
          </div>
        </div>
      );
    }

    return (
      <Faces
        onSelect={this.handleSelectFace}
        onUnselect={this.doNothing}
        options={searchResults}
        onLongPress={this.doNothing}
        select
      />
    );
  }

  printSelectedUsers = () => {
    const { selectedUsers } = this.state;
    const { literals } = this.props;

    if (!selectedUsers.length) {
      return null;
    }

    return (
      <div className='selected_users_wrapper'>
        <div className='title_section'>
          <div className='number'>{selectedUsers.length}</div>
          {literals.selected}
        </div>
        <SimpleCarousel classesList='user_wrapper' showButtons>
          {selectedUsers.map((user) => {
            return (<UserSmallCard key={user.id} user={user} showDeleteButton onDelete={this.handleUnselectFace} />);
          })}
        </SimpleCarousel>
      </div>
    );
  }

  render() {
    const { literals, onCancel, isLoading } = this.props;
    const { search, showPopupInvited } = this.state;
    return (
      <AddUsersWrapper>
        <FeedbackModal
          open={showPopupInvited}
          success
          onClose={this.handleCloseModalInviteFeedback}
          text='Invitation send'
        />
        <Searcher>
          <SearcherInput
            value={search}
            placeholder={literals.searchUsers}
            inputProps={{ 'aria-label': literals.searchUsers }}
            onChange={this.handleSearchChange}
          />
          <img src={IconSearch} onClick={this.searchUsers} alt='search' />
        </Searcher>
        {this.printSearchResults()}
        {this.printSelectedUsers()}
        <div className='text-align-center'>
          <button className='primary' onClick={this.handleInvite}>
            {isLoading ? literals.sending : literals.invite}
          </button>
          <button className='cancel' onClick={onCancel}>{literals.cancel}</button>
        </div>
      </AddUsersWrapper>
    );
  }
}

AddUsers.propTypes = {
  literals: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onInvite: PropTypes.func.isRequired,
  excludedUsers: PropTypes.array,
  connections: PropTypes.array,
};

AddUsers.defaultProps = {
  connections: [],
  excludedUsers: [],
};

export default AddUsers;



// WEBPACK FOOTER //
// ./src/components/AddUsers/components/index.jsx